import { useEffect, useRef } from 'react';

type ContentLinkTarget = { lessonId?: string; assetId?: string };

type Handlers = {
  onLesson: (target: ContentLinkTarget) => void;
  onExtraInfo: (target: ContentLinkTarget) => void;
};

export const matchesContentLink = (item: any, target: ContentLinkTarget) =>
  target.lessonId
    ? String(item?.lessonId) === target.lessonId
    : !!target.assetId && String(item?.assetId) === target.assetId;

export const useContentLinks = (handlers: Handlers) => {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      const link = (ev.target as HTMLElement)?.closest?.(
        'a.teo-content-link'
      ) as HTMLAnchorElement | null;
      if (!link || link.isContentEditable) return;

      ev.preventDefault();
      const target = {
        lessonId: link.dataset.lessonId,
        assetId: link.dataset.assetId,
      };
      if (link.dataset.linkType === 'extra') {
        handlersRef.current.onExtraInfo(target);
      } else {
        handlersRef.current.onLesson(target);
      }
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
};
